// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-groups h2 {
    font-weight: 700;
    font-size: 28px;
    color: #0f062b;
    padding: 5px 0 20px;
    margin-bottom: 0;

}

.group-box {
    padding: 30px;
    border-radius: 16px;
    background-color: #ffff;
}

.group-box .plan-total {
    margin-bottom: 0;
    text-align: center;
    margin-top: 5px;
}

.group-box .plan-total span {
    background: #e1e1f9;
    border-radius: 50px;
    color: #6438b4;
    padding: 1px 10px;
    font-weight: bold;
    font-size: 14px;
}

.dots {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #000000a2;
    display: flex;
    cursor: pointer;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 7px 14px;
    border-radius: 0 5px;
}

.group-box h4 {
    font-weight: 400;
    padding: 10px 0 0 0;
    font-size: 18px;
}

.img-box {
    /*cursor: pointer;*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    height: 100%;
    min-height: 240px;
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background: #f8f9fa;
}

.img-box img {
    object-fit: contain;
}

.group-box .add-box {
    position: relative;
    width: 100%;
    height: 240px;
    border: 2px solid #6c2fbb;;
    border-radius: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.group-box .add-box.disabled {
    cursor: default;
    opacity: 0.8;
}

.group-box .add-box .plus {
    width: 28px;
    height: 26px;
    background: #F8FAFB;
    border-radius: 4px;
    text-align: center;
}

.group-box .col-xl-3 {
    margin-top: 30px;
}

.table {
    cursor: pointer;
}

td {
    line-break: auto;
}

.text-purple {
    color: #6c2fbb !important;
}

.plan-info {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
}

.p-badge {
    background: #e1e1f9;
    border-radius: 20px;
    border: none;
    outline: none;
    color: #6438b4;
    padding: 5px 15px;
    margin: 10px 10px 10px 5px;
    font-weight: bold;
    font-size: 14px;
}

/*.dropdown-menu {*/
/*    transform: translate3d(190px, 30px, 0px) !important;*/
/*}*/
.dropdown-item {
    border: none;
    padding: 5px 10px;
}

.dropdown-menu {
    z-index: 2;
    top: 0px;
    left: -147px !important;
}

@media (max-width: 1500px) {
    .group-box h4 {
        font-size: 20px;
    }

    /*.group-box .add-box {*/
    /*    height: 206px;*/
    /*}*/

}


@media (max-width: 768px) {
    .group-box {
        margin-top: 10px;
    }

    .group-box h4 {
        font-size: 18px;
    }

    .group-box {
        padding: 10px 10px;
        background-color: #ffff;
    }

    .add-box h5 {
        font-size: 18px;
    }

    .group-box .add-box {
        padding: 20px;
    }
}



`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/my-plans/my-plans.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;AACnB;;AAEA,mBAAmB;AACnB,2DAA2D;AAC3D,IAAI;AACJ;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA,wBAAwB;IACxB,qBAAqB;IACrB,IAAI;;AAER;;;AAGA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".my-groups h2 {\n    font-weight: 700;\n    font-size: 28px;\n    color: #0f062b;\n    padding: 5px 0 20px;\n    margin-bottom: 0;\n\n}\n\n.group-box {\n    padding: 30px;\n    border-radius: 16px;\n    background-color: #ffff;\n}\n\n.group-box .plan-total {\n    margin-bottom: 0;\n    text-align: center;\n    margin-top: 5px;\n}\n\n.group-box .plan-total span {\n    background: #e1e1f9;\n    border-radius: 50px;\n    color: #6438b4;\n    padding: 1px 10px;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.dots {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #000000a2;\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    column-gap: 10px;\n    padding: 7px 14px;\n    border-radius: 0 5px;\n}\n\n.group-box h4 {\n    font-weight: 400;\n    padding: 10px 0 0 0;\n    font-size: 18px;\n}\n\n.img-box {\n    /*cursor: pointer;*/\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n    height: 100%;\n    min-height: 240px;\n    width: 100%;\n    border-radius: 16px;\n    overflow: hidden;\n    position: relative;\n    background: #f8f9fa;\n}\n\n.img-box img {\n    object-fit: contain;\n}\n\n.group-box .add-box {\n    position: relative;\n    width: 100%;\n    height: 240px;\n    border: 2px solid #6c2fbb;;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.group-box .add-box.disabled {\n    cursor: default;\n    opacity: 0.8;\n}\n\n.group-box .add-box .plus {\n    width: 28px;\n    height: 26px;\n    background: #F8FAFB;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.group-box .col-xl-3 {\n    margin-top: 30px;\n}\n\n.table {\n    cursor: pointer;\n}\n\ntd {\n    line-break: auto;\n}\n\n.text-purple {\n    color: #6c2fbb !important;\n}\n\n.plan-info {\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n\n.p-badge {\n    background: #e1e1f9;\n    border-radius: 20px;\n    border: none;\n    outline: none;\n    color: #6438b4;\n    padding: 5px 15px;\n    margin: 10px 10px 10px 5px;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n/*.dropdown-menu {*/\n/*    transform: translate3d(190px, 30px, 0px) !important;*/\n/*}*/\n.dropdown-item {\n    border: none;\n    padding: 5px 10px;\n}\n\n.dropdown-menu {\n    z-index: 2;\n    top: 0px;\n    left: -147px !important;\n}\n\n@media (max-width: 1500px) {\n    .group-box h4 {\n        font-size: 20px;\n    }\n\n    /*.group-box .add-box {*/\n    /*    height: 206px;*/\n    /*}*/\n\n}\n\n\n@media (max-width: 768px) {\n    .group-box {\n        margin-top: 10px;\n    }\n\n    .group-box h4 {\n        font-size: 18px;\n    }\n\n    .group-box {\n        padding: 10px 10px;\n        background-color: #ffff;\n    }\n\n    .add-box h5 {\n        font-size: 18px;\n    }\n\n    .group-box .add-box {\n        padding: 20px;\n    }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
